export const getAddinsActionControl = "UXd";
export const sensitivityActionControl = "VXd";
export const sensitivityLearnMoreActionControl = "WXd";
export const showLinkDialogActionControl = "XXd";
export const attachFileActionControl = "YXd";
export const attachSignatureActionControl = "ZXd";
export const highImportanceActionControl = "_Xd";
export const clpLabelDropDownLearnMoreActionControl = "$Xd";
export const clpLabelDropDownLearnMoreToolTipTextActionControl = "aYd";
export const findTimeDescription = "bYd";
export const proofingOptionsDescription = "cYd";
export default {getAddinsActionControl,sensitivityActionControl,sensitivityLearnMoreActionControl,showLinkDialogActionControl,attachFileActionControl,attachSignatureActionControl,highImportanceActionControl,clpLabelDropDownLearnMoreActionControl,clpLabelDropDownLearnMoreToolTipTextActionControl,findTimeDescription,proofingOptionsDescription};